<script>
  import { onMount, createEventDispatcher, onDestroy } from 'svelte';
  import PuzzleOfTheDayBoard from '../puzzle-of-the-day-board.js';

  export let stake = 2.0;
  export let token = "your-token";
  export let assetsUrl = '/puzzle_assets/chessboard/';

  let puzzleBoardElement;
  let puzzleBoard;
  
  const dispatch = createEventDispatcher();

  // Puzzle state
  let timeRemaining = 0;
  let puzzleRating = 0;
  let userRating = 0;
  let isGameOver = false;
  let isSolved = false;
  let endGameInfo = null;


  onMount(() => {
    const initPuzzleBoard = () => {
      if (puzzleBoardElement) {
        puzzleBoard = new PuzzleOfTheDayBoard(puzzleBoardElement, stake, token, assetsUrl);
        
        puzzleBoard.on('puzzleSolved', handlePuzzleSolved);
        puzzleBoard.on('puzzleFailed', handlePuzzleFailed);
        
        // Listen for puzzle initialization
        puzzleBoard.on('puzzleInit', handlePuzzleInit);

        // Listen for puzzle continuation
        puzzleBoard.on('puzzleContinue', handlePuzzleContinue);
        puzzleBoard.on('clockStop', handleClockStop);

        console.log("Puzzle board initialized");

        // Add resize event listener
        window.addEventListener('resize', handleResize);
      } else {
        console.log("Puzzle board element not found, retrying...");
        setTimeout(initPuzzleBoard, 100);
      }
    };

    initPuzzleBoard();

    return () => {
      // Remove resize event listener on component destroy
      window.removeEventListener('resize', handleResize);
    };
  });

  function handleResize() {
    if (puzzleBoard && puzzleBoard.resize) {
      puzzleBoard.resize();
    }
  }


  function handlePuzzleInit(data) {
    const { first_move, init_fen, puzzle_rating, time_remaining, to_play, user_rating } = data;
    puzzleRating = puzzle_rating;
    userRating = user_rating;
    timeRemaining = time_remaining;
    isGameOver = false;
    isSolved = false;
    endGameInfo = null;

    dispatch('puzzleInit', data);
  }
  function handleClockStop(data) {
    dispatch('clockStop', data);
  }

  function handlePuzzleContinue(data) {
    const { opp_move, time_remaining } = data;
    
    dispatch('puzzleContinue', data);
  }

  function handlePuzzleSolved(data) {
    isGameOver = true;
    isSolved = data.solved;
    endGameInfo = data;

    dispatch('puzzleSolved', data);
  }
  function handlePuzzleFailed(data) {
    isGameOver = true;
    isSolved = false;
    endGameInfo = data;


    dispatch('puzzleFailed', data);
  }



  // Function to send a message to the puzzle board
  export function sendMessage(message) {
    if (puzzleBoard) {
      puzzleBoard.sendSvelteMessage(message);
    } else {
      console.error('Puzzle board not initialized');
    }
  }

</script>

<div class="board-container">
  <div class="board-style" bind:this={puzzleBoardElement}>
    <!-- The chessboard will be rendered here -->
  </div>
</div>

<style>
  .board-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-height: 0;
  }
  .board-style {
    box-shadow: 10px 10px 79px 18px rgba(0,0,0,0.75);
    z-index: 1;
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    max-width: 100vmin;
    max-height: 100vmin;
    margin: 0 auto;
  }
</style>
